module.exports = __webpack_public_path__ + "static/media/Kliber.3171a0a9.png";